import { Tab, TabList, Tabs, VStack } from '@chakra-ui/react';
import { FC } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { Container } from '../../components/Layouts/Container';

export const OrganizationAdminPage: FC = () => {
  const location = useLocation();

  const tabs = [
    { path: 'members', label: 'Members' },
    { path: 'integration-connections', label: 'Integrations' },
  ];

  const activeIndex = tabs.findIndex((tab) =>
    location.pathname.includes(tab.path)
  );

  return (
    <Container maxWidth="container.xl" overflowX="auto">
      <VStack alignItems="stretch" spacing={4}>
        <Tabs index={activeIndex !== -1 ? activeIndex : 0}>
          <TabList>
            {tabs.map((tab) => (
              <Tab key={tab.path} as={NavLink} to={tab.path}>
                {tab.label}
              </Tab>
            ))}
          </TabList>
        </Tabs>

        <Outlet />
      </VStack>
    </Container>
  );
};
